import { AdditionalColors } from '@gc-bridge/theme/colors';
import { Link, LinkProps, styled } from '@mui/material';

const StyledLink = styled(Link)(({ theme: { palette, typography } }) => ({
  fontFamily: typography.fontFamily,
  textTransform: 'uppercase',
  backgroundColor: palette.primary.main,
  color: palette.primary.contrastText,
  borderRadius: '4px',
  padding: '8px 22px',
  boxShadow: `0px 3px 1px -2px ${AdditionalColors.BlackOpacity20}, \
              0px 2px 2px 0px ${AdditionalColors.BlackOpacity14}, \
              0px 1px 5px 0px ${AdditionalColors.BlackOpacity12}`,
  '&:hover': {
    textDecoration: 'none',
    cursor: 'pointer',
  },
}));

interface Props {
  label: string;
  url: string;
}

export function LinkButton({ label, url, ...rest }: Props & LinkProps) {
  return (
    <StyledLink component="a" href={url} {...rest}>
      {label}
    </StyledLink>
  );
}
